import { Bell, Ellipsis, Menu, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import ProfileAvatar from "./ProfileAvatar";
import { getImageFromAssetFolder } from "../utils/assets";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const dropdownRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const toggleDropdown = () => setIsOpen(!isOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <nav className="flex items-center justify-between px-6 py-4 border-b">
        <div className="flex items-center space-x-8">
          <Link to={"/"}>
            <img
              src={getImageFromAssetFolder("short_logo.png")}
              alt="Logo"
              className="w-8 h-8 rounded-full"
            />
          </Link>
          <div className="max-md:hidden flex items-center space-x-8">
            <Link to={"/app/groups"} className="font-medium">
              Find Groups
            </Link>
            <Link to={"/app/exam-syllabus"} className="font-medium">
              Find Syllabus
            </Link>
            <Link to={"/faqs"} className="font-medium">
              My Results
            </Link>
            <div className="relative inline-block text-left" ref={dropdownRef}>
              <button
                onClick={toggleDropdown}
                className="p-2 rounded-full hover:bg-background"
                aria-haspopup="true"
                aria-expanded={isOpen}
              >
                <Ellipsis className="h-5 w-5 text-gray-600" />
              </button>

              {isOpen && (
                <div className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div
                    className="py-1"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="options-menu"
                  >
                    <Link
                      href="#"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                      role="menuitem"
                    >
                      Bookmarked Questions
                    </Link>
                    <Link
                      href="#"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                      role="menuitem"
                    >
                      Refer App
                    </Link>
                    <Link
                      href="#"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                      role="menuitem"
                    >
                      Rate App
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex items-center">
          <button className="p-2 rounded-full hover:bg-gray-100">
            <Bell />
          </button>
          <button
            onClick={toggleMenu}
            className="md:hidden p-2 rounded-full hover:bg-gray-100 lg:hidden"
          >
            <Menu className="h-6 w-6" />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`z-50 fixed inset-y-0 right-0 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        } lg:hidden`}
      >
        <div className="p-4">
          <button onClick={toggleMenu} className="mb-4">
            <X className="h-6 w-6" />
          </button>
          <div className="flex flex-col space-y-8 px-4">
            <button onClick={toggleMenu}>
              <ProfileAvatar />
            </button>
            <Link href="/app/groups">
              <button onClick={toggleMenu}>Find Groups</button>
            </Link>
            <Link href="/app/exam-syllabus" className="">
              <button onClick={toggleMenu}>Find Syllabus</button>
            </Link>
            <Link href="/my-results" className="">
              <button onClick={toggleMenu}>My Results</button>
            </Link>
            <Link href="/app">
              <button onClick={toggleMenu}>Bookmarked Questions</button>
            </Link>
            <Link href="/app" className="">
              <button onClick={toggleMenu}>Refer App</button>
            </Link>
            <Link href="/app" className="">
              <button onClick={toggleMenu}>Rate App</button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
